// extracted by mini-css-extract-plugin
module.exports = {"postTitle":"markdown-post-module--postTitle--3Gukd","postContainer":"markdown-post-module--postContainer--zNCK9","postDate":"markdown-post-module--postDate--C0NY2"};